export function getFileExtension(fileType: string) {
  switch (fileType) {
    case "image/jpeg":
      return "jpg";
    case "image/svg+xml":
      return "svg";
    case "image/png":
      return "png";
    default:
      return "jpg";
  }
}
